import React, { useEffect, useRef } from 'react'
import { timingFunctions } from 'polished'
import { useSpring, animated, useTransition, config } from 'react-spring'
import styled, { css } from 'styled-components'
import useDimensions from 'react-use-dimensions'
import { isNumber } from 'lodash'

const BREATH =
  'M149,90 L149,0 L181.794521,0 C205.219178,0 215.69863,8.38356164 215.69863,25.890411 C215.69863,33.9041096 212.739726,39.5753425 207.931507,43.2739726 C214.342466,47.0958904 217.794521,53.1369863 217.794521,62.0136986 C217.794521,81.739726 204.356164,90 181.178082,90 L149,90 Z M182.657534,55.8493151 L173.657534,55.8493151 L173.657534,67.8082192 L182.041096,67.8082192 C188.821918,67.8082192 191.164384,65.5890411 191.164384,61.3972603 C191.164384,57.3287671 188.945205,55.8493151 182.657534,55.8493151 Z M183.39726,22.0684932 L173.657534,22.0684932 L173.657534,33.1643836 L183.643836,33.1643836 C188.328767,33.1643836 190.424658,30.6986301 190.424658,27.369863 C190.424658,24.0410959 188.205479,22.0684932 183.39726,22.0684932 Z M240.561644,90 L240.561644,0 L273.232877,0 C295.794521,0 307.876712,14.6712329 307.876712,31.8082192 C307.876712,43.5205479 302.945205,54 292.835616,59.6712329 L309.972603,90 L281,90 L266.328767,60.4109589 L266.328767,90 L240.561644,90 Z M272,23.4246575 L266.328767,23.4246575 L266.328767,41.3013699 L272,41.3013699 C276.931507,41.3013699 281.493151,38.3424658 281.493151,32.3013699 C281.493151,26.5068493 276.931507,23.4246575 272,23.4246575 Z M330.643836,90 L330.643836,0 L384.027397,0 L384.027397,23.6712329 L356.287671,23.6712329 L356.287671,32.9178082 L384.027397,32.9178082 L384.027397,56.5890411 L356.287671,56.5890411 L356.287671,66.4520548 L384.027397,66.4520548 L384.027397,90 L330.643836,90 Z M404.821918,90 L434.657534,0 L458.821918,0 L488.534247,90 L462.767123,90 L459.438356,79.2739726 L433.794521,79.2739726 L430.465753,90 L404.821918,90 Z M452.410959,56.5890411 L446.739726,37.9726027 L440.821918,56.5890411 L452.410959,56.5890411 Z M509.945205,90 L509.945205,23.7945205 L488.863014,23.7945205 L488.863014,0 L555.068493,0 L555.068493,23.7945205 L534.60274,23.7945205 L534.60274,90 L509.945205,90 Z M621.849315,90 L621.849315,57.6986301 L603.972603,57.6986301 L603.972603,90 L578.082192,90 L578.082192,0 L603.972603,0 L603.972603,31.5616438 L621.849315,31.5616438 L621.849315,0 L647.739726,0 L647.739726,90 L621.849315,90 Z'

const MEDITATION =
  'M5.68434189e-14,88.8 L5.68434189e-14,1.2 L25.32,1.2 L43.44,26.4 L62.28,1.2 L86.28,1.2 L86.28,88.8 L61.2,88.8 L61.2,41.52 L43.44,65.52 L25.08,40.92 L25.08,88.8 L5.68434189e-14,88.8 Z M108.68,88.8 L108.68,1.2 L160.64,1.2 L160.64,24.24 L133.64,24.24 L133.64,33.24 L160.64,33.24 L160.64,56.28 L133.64,56.28 L133.64,65.88 L160.64,65.88 L160.64,88.8 L108.68,88.8 Z M183.04,88.8 L183.04,1.2 L211.6,1.2 C236.56,1.2 256.48,20.16 256.48,45 C256.48,69.96 236.92,88.8 211.6,88.8 L183.04,88.8 Z M211.6,24.72 L208,24.72 L208,65.28 L211.6,65.28 C223.36,65.28 230.92,56.04 230.92,45 C230.92,33.96 223,24.72 211.6,24.72 Z M278.64,88.8 L278.64,1.2 L304.2,1.2 L304.2,88.8 L278.64,88.8 Z M347,88.8 L347,24.36 L326.48,24.36 L326.48,1.2 L390.92,1.2 L390.92,24.36 L371,24.36 L371,88.8 L347,88.8 Z M392.68,88.8 L421.72,1.2 L445.24,1.2 L474.16,88.8 L449.08,88.8 L445.84,78.36 L420.88,78.36 L417.64,88.8 L392.68,88.8 Z M439,56.28 L433.48,38.16 L427.72,56.28 L439,56.28 Z M495,88.8 L495,24.36 L474.48,24.36 L474.48,1.2 L538.92,1.2 L538.92,24.36 L519,24.36 L519,88.8 L495,88.8 Z M561.32,88.8 L561.32,1.2 L586.88,1.2 L586.88,88.8 L561.32,88.8 Z M653.68,90 C628.48,90 608.92,69.96 608.92,45 C608.92,20.16 628.48,0 653.68,0 C678.64,0 698.56,20.16 698.56,45 C698.56,69.96 679,90 653.68,90 Z M653.68,65.28 C665.44,65.28 673,56.04 673,45 C673,33.96 665.08,24.72 653.68,24.72 C642.28,24.72 634.48,33.96 634.48,45 C634.48,56.04 641.92,65.28 653.68,65.28 Z M720.72,88.8 L720.72,1.2 L746.4,1.2 L772.44,42.12 L772.44,1.2 L797.4,1.2 L797.4,88.8 L773.64,88.8 L745.68,44.76 L745.68,88.8 L720.72,88.8 Z'

const MOVEMENT =
  'M192.392 44.995c0-10.994-8.058-20.196-19.66-20.196-11.6 0-19.537 9.202-19.537 20.196 0 10.994 7.571 20.195 19.538 20.195s19.66-9.201 19.66-20.195m-65.207 0c0-24.737 19.904-44.813 45.547-44.813 25.398 0 45.67 20.076 45.67 44.813 0 24.855-19.905 44.813-45.67 44.813-25.643 0-45.547-19.958-45.547-44.813M233.545 1.377h26.62l14.531 46.605 13.798-46.605h26.01l-26.376 87.235h-26.864zM339.292 1.377h52.873v22.944H364.69v8.962h27.475v22.944H364.69v9.56h27.475v22.825h-52.873zM419.029 1.377h25.765l18.438 25.096 19.172-25.096h24.422v87.235h-25.521V41.529l-18.073 23.9-18.682-24.498v47.681h-25.521zM533.692 1.377h52.873v22.944h-27.474v8.962h27.474v22.944h-27.474v9.56h27.474v22.825h-52.873zM613.429 1.377h26.132l26.498 40.749V1.377h25.398v87.235H667.28l-28.451-43.856v43.856h-25.4zM739.204 24.441h-20.88V1.378h65.573v23.063h-20.27v64.171h-24.423zM76.462.832L57.294 25.927 38.857.832H13.096v87.235h25.518V40.386l18.68 24.497 18.07-23.9v47.084h25.517V.832z'

const list = [MOVEMENT, BREATH, MEDITATION]

const WIDTH = 798

const START = 'translateX(0%)'
const TRANSPARENT = 'translateX(-66%)'

const TIME = 2000

const Meditation = ({ index, reset, show, ...props }) => {
  const [ref, { height, width }] = useDimensions()

  const gradient = useSpring({
    from: {
      transform: START,
    },
    transform: show ? TRANSPARENT : START,
    config: {
      duration: show ? TIME : TIME / 2,
      ease: timingFunctions('easeInOutQuad'),
    },
  })

  const { opacity } = useSpring({
    from: {
      opacity: 0,
    },
    opacity: show ? 1 : 0,
    config: {
      duration: show ? TIME : TIME / 2,
      ease: timingFunctions('easeInOutQuad'),
    },
  })

  const { transform } = useSpring({
    from: {
      transform: 'scale(0.95)',
    },
    transform: reset ? 'scale(0.95)' : 'scale(1)',
    config: {
      duration: TIME,
      ease: timingFunctions('easeOutExpo'),
    },
  })

  const w = !!isNumber(width) ? width : WIDTH
  const h = !!isNumber(height) ? height : 90

  return (
    <Container height={h} show={show.toString()} style={{ opacity }}>
      <div>
        <animated.div style={{ transform }}>
          <svg width={width} height={90} viewBox={`0 0 ${WIDTH} 90`} {...props}>
            <g fill="#3E4680" fillRule="evenodd">
              <path d={list[index]} />
            </g>
          </svg>
        </animated.div>
        <Mask width={width} height={h} style={gradient}>
          <div />
          <div />
          <div />
        </Mask>
        <SpacerSvg ref={ref} viewBox={`0 0 ${WIDTH} 90`} {...props} />
      </div>
    </Container>
  )
}

export default Meditation

const SpacerSvg = styled.svg`
  width: 80vw;
  height: auto;
  max-width: ${WIDTH}px;
`

const Container = styled(animated.div)`
  ${({ height, width, show }) => css`
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    min-height: ${height}px;
    z-index: 1;

    ${!!show &&
      css`
        z-index: 2;
      `};

    > div {
      position: relative;
      width: 100%;

      svg {
        left: 50%;
        transform: translateX(-50%);
      }
    }

    svg {
      position: absolute;
      top: 0;
      width: ${width}px;
      min-height: ${height}px;
    }
  `};
`

const Mask = styled(animated.div)`
  ${({ height, width }) => css`
    display: flex;
    position: absolute;
    min-height: ${height}px;

    div {
      width: ${width * 3}px;
      min-height: ${height}px;
      background: #fff;

      &:nth-child(2) {
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 100%
        );
      }

      &:nth-child(3) {
        background: transparent;
      }
    }
  `};
`
